import { defineMessages } from 'react-intl';

export const autoVerifyCrossSessionWatcherMessages = defineMessages({
  readyTitle: {
    defaultMessage: 'Ready for review',
    id: '6rGIjl3Zmw',
    description:
      'Title of the toast shown when auto-verify completes on a session the user has navigated away from',
  },
  readyOtherSessionDescription: {
    defaultMessage: 'Auto-verify finished on another session',
    id: 'lf2XwRMfA4',
    description: 'Description of the cross-session auto-verify completion toast',
  },
  viewResults: {
    defaultMessage: 'View results',
    id: 'DpW6xjKAed',
    description:
      'Toast action that navigates to the completed session and opens the verification drawer',
  },
});
